import React, {
  useContext,
} from 'react';
import classNames from 'classnames';
import {
  FormConfigStore, AppFormField, FormUtils, DeliveryInfo,
} from 'ewp-common';

import {
  Fieldset,
} from '@ktag/styleguide/dist/react';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
}

const ResidenceInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const configs = formConfigState?.data?.labelsMap ?? {};

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <DeliveryInfo
        formConfigs={configs}
      />
      <Fieldset>
        <AppFormField
          formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
          config={configs.fieldComments}
          multiline
        />
      </Fieldset>
    </div>
  );
};

ResidenceInfo.defaultProps = {
  id: '',
  className: 'residenceInfo',
  additionalClassNames: '',
};

export default ResidenceInfo;
